import { AppState } from '../reducers';

const embeddedResourceSelector = (state: AppState) => state.embedded;

export const isIntegrationPanelShownForCallSelector = (callId: string) => (state: AppState) => {
  const embedded = embeddedResourceSelector(state);
  return embedded.integrationPanelShownForCalls.includes(callId);
};
